export default __webpack_public_path__ + "d36e38b13429f45c7973f9a2116e509d.woff2";